export default "__VITE_ASSET__CG1kTfJo__"